export default {
  // START:: GET APP LOCALE
  getAppLocale(state) {
    return state.dr_mohamed_admin_dashboard_language;
  },
  // END:: GET APP LOCALE
};
